<template>
  <div>
    <v-card>
      <v-flex text-md-center v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-flex>
      <div v-else>
        <show :menu="selectedMenu"></show>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Show from "@/components/Menus/Show";
export default {
  data() {
    return {
      loading: true,
      interval: {}
    };
  },
  components: {
    Show
  },
  methods: {
    ...mapActions("menus", ["fetchMenu"]),
    ...mapMutations("menus", ["setMenu"]),
    getMenu() {
      this.loading = true;
      let title = this.$route.params.title;
      this.fetchMenu(title);
      this.interval = setInterval(() => {
        if (this.selectedMenu) {
          clearInterval(this.interval);
          return (this.loading = false);
        }
      }, 1000);
    }
  },
  computed: {
    ...mapState("menus", ["selectedMenu"])
  },
  mounted() {
    this.getMenu();
  },
  watch: {
    "$route.params.title": function() {
      this.getMenu();
    }
  },
  destroyed() {
    this.setMenu(null);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>